// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-74d38ad1] .el-table-emptyImg .empty {\n  margin-top: 30px;\n  margin-bottom: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
